import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { useMemo } from 'react';
import { ENDPOINTS } from './../../endpoints';
import { Service } from './../base';
import dynamicAxios from './../../utils/axios';
import useServices from '../../hooks/useServices';
import { indexWorkersQuery } from './graphqlQueries';
import { indexEmployerJobApplicationsQuery } from '../useWorkerJobPositions/graphqlQueries';

var ServiceWorker = /*#__PURE__*/function (_Service) {
  _inherits(ServiceWorker, _Service);

  var _super = _createSuper(ServiceWorker);

  function ServiceWorker() {
    _classCallCheck(this, ServiceWorker);

    return _super.apply(this, arguments);
  }

  _createClass(ServiceWorker, [{
    key: "fetchWorkers",
    value: function fetchWorkers(_ref) {
      var jobPositionId = _ref.jobPositionId,
          limit = _ref.limit,
          offset = _ref.offset,
          order_by = _ref.order_by,
          filters = _ref.filters,
          useCache = _ref.useCache;
      var appliedFilters = filters || {};
      return this.axiosInstance.post(ENDPOINTS.workers.graphql, {
        query: indexWorkersQuery,
        variables: _objectSpread(_objectSpread({
          limit: limit,
          offset: offset,
          job_position_id: jobPositionId
        }, appliedFilters), {}, {
          order_by: order_by
        })
      });
    }
  }, {
    key: "updateResearchStatus",
    value: function updateResearchStatus(_ref2) {
      var workerId = _ref2.workerId,
          statusKey = _ref2.statusKey;
      return this.axiosInstance.patch(ENDPOINTS.workers.updateResearchStatus, {
        worker_id: workerId,
        status_key: statusKey
      });
    }
  }, {
    key: "fetchActiveApplications",
    value: function fetchActiveApplications(_ref3) {
      var workerId = _ref3.workerId;
      return this.axiosInstance.get(ENDPOINTS.workers.activeApplications, {
        params: {
          id: workerId
        }
      });
    }
  }, {
    key: "fetchWorker",
    value: function fetchWorker(workerId) {
      return this.axiosInstance.get("".concat(ENDPOINTS.workers.root, "/").concat(workerId));
    }
  }, {
    key: "createWorker",
    value: function createWorker(workerData) {
      return this.axiosInstance.post("".concat(ENDPOINTS.workers.createWorker), workerData, {
        headers: {
          'content-type': 'application/json'
        }
      });
    }
  }, {
    key: "updateWorker",
    value: function updateWorker(_ref4) {
      var workerId = _ref4.workerId,
          params = _ref4.params;
      return this.axiosInstance.patch("".concat(ENDPOINTS.workers.root, "/").concat(workerId), params);
    }
  }, {
    key: "sendMissingCVData",
    value: function sendMissingCVData(payload) {
      return this.axiosInstance.post(ENDPOINTS.workers.uploadCv_2, payload, {
        headers: {
          'content-type': 'application/json'
        }
      });
    }
  }, {
    key: "uploadCV",
    value: function uploadCV(_ref5) {
      var workerId = _ref5.workerId,
          cv = _ref5.cv,
          jobPositionId = _ref5.jobPositionId;
      var formData = new FormData();
      if (workerId) formData.append('user_id', workerId);
      if (jobPositionId) formData.append('job_position_id', jobPositionId);
      formData.append('cv', cv);
      return this.axiosInstance.post(ENDPOINTS.workers.uploadCv, formData, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      });
    }
  }, {
    key: "deleteCV",
    value: function deleteCV(workerId) {
      return this.axiosInstance["delete"](ENDPOINTS.workers.deleteCv, {
        data: {
          user_id: workerId
        }
      });
    }
  }, {
    key: "sendEmailToWorker",
    value: function sendEmailToWorker(_ref6) {
      var email = _ref6.email,
          subject = _ref6.subject,
          content = _ref6.content;
      return this.axiosInstance.post(ENDPOINTS.workers.sendEmail, {
        email: email,
        subject: subject,
        content: content
      });
    }
  }, {
    key: "sendAccessEmail",
    value: function sendAccessEmail(workerId) {
      return this.axiosInstance.post(ENDPOINTS.workers.sendAccessEmail, {
        worker_id: workerId
      });
    }
  }, {
    key: "deleteWorker",
    value: function deleteWorker(workerId) {
      return this.axiosInstance["delete"](ENDPOINTS.workers.root, {
        params: {
          id: workerId
        }
      });
    }
  }, {
    key: "fetchWorkerByReferralCode",
    value: function fetchWorkerByReferralCode(referralCode) {
      return this.axiosInstance.get(ENDPOINTS.workers.scout, {
        params: {
          referral_code: referralCode
        }
      });
    }
  }, {
    key: "fetchWorkerAsset",
    value: function fetchWorkerAsset(url) {
      return this.axiosInstance.get("".concat(ENDPOINTS.workers.asset), {
        params: {
          url: url
        },
        responseType: 'blob'
      });
    }
  }, {
    key: "fetchResearchStatus",
    value: function fetchResearchStatus() {
      return this.axiosInstance.get(ENDPOINTS.workers.researchStatus);
    }
  }, {
    key: "fetchCvParsingJobStatus",
    value: function fetchCvParsingJobStatus(workerId) {
      return this.axiosInstance.get(ENDPOINTS.workers.cvParsingJobStatus, {
        params: {
          id: workerId
        }
      });
    }
  }, {
    key: "fetchBoostStatus",
    value: function fetchBoostStatus(worker_id) {
      return this.axiosInstance.get("".concat(ENDPOINTS.workers.boostStatus), {
        params: {
          id: worker_id
        }
      });
    }
  }, {
    key: "fetchApplicationStatus",
    value: function fetchApplicationStatus(worker_id) {
      return this.axiosInstance.get(ENDPOINTS.workers.applicationStatus, {
        params: {
          worker_id: worker_id
        }
      });
    }
  }, {
    key: "fetchByNativeCVPublicUsername",
    value: function fetchByNativeCVPublicUsername(_ref7) {
      var username = _ref7.username,
          collect_metrics = _ref7.collect_metrics;
      return this.axiosInstance.get("".concat(ENDPOINTS.workers.nativeCV, "/").concat(username), {
        params: {
          collect_metrics: collect_metrics
        }
      });
    }
  }, {
    key: "checkEmailValidity",
    value: function checkEmailValidity(email) {
      return this.axiosInstance.get(ENDPOINTS.workers.emailValidity, {
        params: {
          email: email
        }
      });
    }
  }, {
    key: "sendAsset",
    value: function sendAsset(_ref8) {
      var file = _ref8.file,
          type = _ref8.type;
      var formData = new FormData();
      formData.append('asset', file);
      formData.append('type', type);
      return this.axiosInstance.post(ENDPOINTS.workers.asset, formData);
    }
  }, {
    key: "sendPicture",
    value: function sendPicture(_ref9) {
      var email = _ref9.email,
          picture = _ref9.picture;
      var formData = new FormData();
      formData.append('email', email || '');
      formData.append('picture', picture);
      return this.axiosInstance.post(ENDPOINTS.workers.sendPicture, formData);
    }
  }, {
    key: "deleteAsset",
    value: function deleteAsset(asset) {
      var _asset$url;

      return this.axiosInstance["delete"]("".concat(ENDPOINTS.workers.asset, "/").concat(encode((_asset$url = asset.url) !== null && _asset$url !== void 0 ? _asset$url : '')));
    }
  }, {
    key: "listSavedResearches",
    value: function listSavedResearches(_ref10) {
      var limit = _ref10.limit,
          offset = _ref10.offset,
          email = _ref10.email;
      return this.axiosInstance.get(ENDPOINTS.workers.savedResearches, {
        params: {
          limit: limit,
          offset: offset,
          email: email
        }
      });
    }
  }, {
    key: "saveJPResearch",
    value: function saveJPResearch(params) {
      return this.axiosInstance.post(ENDPOINTS.workers.savedResearch, params);
    }
  }, {
    key: "fetchSavedResearch",
    value: function fetchSavedResearch(_ref11) {
      var researchId = _ref11.researchId;
      return this.axiosInstance.get(ENDPOINTS.workers.savedResearch, {
        params: {
          id: researchId
        }
      });
    }
  }, {
    key: "updateSavedResearch",
    value: function updateSavedResearch(params) {
      return this.axiosInstance.patch(ENDPOINTS.workers.savedResearch, _objectSpread({}, params));
    }
  }, {
    key: "deleteSavedResearch",
    value: function deleteSavedResearch(_ref12) {
      var researchId = _ref12.researchId,
          email = _ref12.email;
      return this.axiosInstance["delete"](ENDPOINTS.workers.savedResearch, {
        params: {
          id: researchId,
          email: email
        }
      });
    }
  }, {
    key: "fetchSimilarWorkers",
    value: function fetchSimilarWorkers(_ref13) {
      var workerId = _ref13.workerId,
          jobPositionId = _ref13.jobPositionId,
          limit = _ref13.limit,
          limitWorkerDistance = _ref13.limitWorkerDistance,
          workerDistanceRadius = _ref13.workerDistanceRadius;
      return this.axiosInstance.get("".concat(ENDPOINTS.workers.similarWorkers, "/").concat(workerId), {
        params: {
          limit: limit,
          job_position_id: jobPositionId,
          limit_worker_distance: limitWorkerDistance,
          worker_distance_radius: workerDistanceRadius
        }
      });
    }
  }, {
    key: "fetchSimilarWorkersUsingDirectSemanticSearch",
    value: function fetchSimilarWorkersUsingDirectSemanticSearch(_ref14) {
      var jobPositionId = _ref14.jobPositionId,
          maxRestaurantDistance = _ref14.maxRestaurantDistance;
      return this.axiosInstance.get("".concat(ENDPOINTS.workers.root, "/job_positions/").concat(jobPositionId, "/similar"), {
        params: {
          max_restaurant_distance: maxRestaurantDistance
        }
      });
    }
  }, {
    key: "fetchEmployerJobApplications",
    value: function fetchEmployerJobApplications(_ref15) {
      var limit = _ref15.limit,
          offset = _ref15.offset,
          employerId = _ref15.employerId,
          search_vector = _ref15.search_vector,
          spontaneous_applications = _ref15.spontaneous_applications,
          organizationId = _ref15.organizationId;
      return this.axiosInstance.post(ENDPOINTS.workerJobPositions.graphql, {
        query: indexEmployerJobApplicationsQuery,
        variables: {
          limit: limit,
          offset: offset,
          employer_id: employerId,
          search_vector: search_vector,
          spontaneous_applications: spontaneous_applications,
          organization_id: organizationId
        }
      });
    } // Worker References related functions //

  }, {
    key: "listWorkerPastExperiences",
    value: function listWorkerPastExperiences(_ref16) {
      var limit = _ref16.limit,
          offset = _ref16.offset,
          workerId = _ref16.workerId;
      return this.axiosInstance.get(ENDPOINTS.workers.workerPastExperiences, {
        params: {
          limit: limit,
          offset: offset,
          worker_id: workerId
        }
      });
    }
  }, {
    key: "showWorkerPastExperience",
    value: function showWorkerPastExperience(_ref17) {
      var id = _ref17.id;
      return this.axiosInstance.get("".concat(ENDPOINTS.workers.workerPastExperiences, "/").concat(id));
    }
  }, {
    key: "updateWorkerPastExperience",
    value: function updateWorkerPastExperience(params) {
      return this.axiosInstance.patch("".concat(ENDPOINTS.workers.workerPastExperiences), params);
    }
  }, {
    key: "createWorkerPastExperienceInconsistency",
    value: function createWorkerPastExperienceInconsistency(params) {
      return this.axiosInstance.post(ENDPOINTS.workers.workerPastExperienceInconsistencies, params);
    }
  }, {
    key: "listWorkerReferences",
    value: function listWorkerReferences(_ref18) {
      var limit = _ref18.limit,
          offset = _ref18.offset,
          workerId = _ref18.workerId;
      return this.axiosInstance.get(ENDPOINTS.workers.references, {
        params: {
          limit: limit,
          offset: offset,
          worker_id: workerId
        }
      });
    }
  }, {
    key: "createWorkerReference",
    value: function createWorkerReference(params) {
      return this.axiosInstance.post(ENDPOINTS.workers.references, params);
    }
  }, {
    key: "updateWorkerReference",
    value: function updateWorkerReference(params) {
      return this.axiosInstance.patch("".concat(ENDPOINTS.workers.references, "/").concat(params.id), params);
    }
  }, {
    key: "fetchWorkerReports",
    value: function fetchWorkerReports(workerId) {
      return this.axiosInstance.get("".concat(ENDPOINTS.workers.root, "/reports"), {
        params: {
          worker_id: workerId
        }
      });
    }
  }, {
    key: "createWorkerReport",
    value: function createWorkerReport(workerReport) {
      return this.axiosInstance.post("".concat(ENDPOINTS.workers.root, "/reports"), workerReport);
    }
  }, {
    key: "updateWorkerReport",
    value: function updateWorkerReport(workerReport) {
      return this.axiosInstance.patch("".concat(ENDPOINTS.workers.root, "/reports/").concat(workerReport.id), workerReport);
    }
  }, {
    key: "deleteWorkerReport",
    value: function deleteWorkerReport(reportId) {
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.workers.root, "/reports/").concat(reportId));
    }
  }]);

  return ServiceWorker;
}(Service);

export var workersService = function workersService(_ref19) {
  var baseUrl = _ref19.baseUrl,
      jwt = _ref19.jwt;
  return new ServiceWorker(dynamicAxios(baseUrl, jwt));
};
export var encode = function encode(url) {
  return encodeURIComponent(url).replace(/!/g, '%21').replace(/~/g, '%7E').replace(/\*/g, '%2A').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/%20/g, '+');
};
export function useWorkersService() {
  var _useServices = useServices(),
      baseUrl = _useServices.baseUrl,
      jwt = _useServices.jwt;

  return useMemo(function () {
    return new ServiceWorker(dynamicAxios(baseUrl, jwt));
  }, [baseUrl, jwt]);
}
export default useWorkersService;
export * from './types';